package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.mikepenz.markdown.m3.Markdown
import com.mikepenz.markdown.model.markdownPadding
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.HtmlSpanAnnotator
import one.healthium.insights.ui.components.defaultMarkdownTypography

@Composable
internal fun ContentText(
    modifier: Modifier = Modifier,
    item: ContentEntry.TextEntry,
) {
    Markdown(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 24.dp, vertical = 12.dp),
        content = item.text,
        padding = markdownPadding(block = 8.dp),
        typography = defaultMarkdownTypography(),
        annotator = remember { HtmlSpanAnnotator() },
    )
}